<template>  
        <timeline-list title="Zaman qrafiki" dark-mode>
          <timeline-item
            color="excel"
            icon_color="excel"
            icon="check-bold"
            title="Ərizə daxil olunub"
            date-time="02.09.2025 13:00"
            dark-mode
          />
          <TimelineItem
            color="excel"
            icon_color="excel"
            icon="check-bold"
            title="Təstiqə göndərilib"
            date-time="02.09.2025 13:10"
            dark-mode
          />  
          <TimelineItem 
            color="excel"
            icon_color="excel"
            icon="check-bold" 
            title="Sığortaçı imzası"  
            :badges="['No Deadline']" 
            dark-mode
          />
          <TimelineItem 
            icon="bi bi-hourglass-split mb-1"
            :done="false"
            title="Müştəri imzası"
            color="excel"
            :badges="['No Deadline']"
            dark-mode
          />
          <TimelineItem 
            icon="bi bi-hourglass-split mb-1"
            :done="false"
            title="Kurator imzası"
            color="excel"
            :badges="['No Deadline']"
            dark-mode
          />
          <TimelineItem
            icon="bi bi-hourglass-split mb-1"
            :done="false"
            title="Bildiriş"
            color="excel"
            :badges="['No Deadline']"
            dark-mode
          />
        </timeline-list> 
</template>

<script>
import TimelineList from "./Components/TimelineList.vue";
import TimelineItem from "./Components/TimelineItem.vue";
export default {
  name: "Timeline",
  components: { TimelineList, TimelineItem },
};
</script>
